// @flow
import React from 'react';
import { useParams } from 'react-router-dom';
import { SubmissionPage } from './submission-page';

const SubmissionPageContainer = () => {
  const { urlId } = useParams();
  return <SubmissionPage urlId={urlId || ''} />;
};

export { SubmissionPageContainer };
export default SubmissionPageContainer;
